import React from 'react';
import { apiClient } from 'services/api-client';

const apiClientContext = React.createContext(apiClient);

const useApiClient = (): typeof apiClient => React.useContext(apiClientContext);

export default useApiClient;
